import { render, staticRenderFns } from "./WorkContactPickerWithInputField.vue?vue&type=template&id=56ea6578"
import script from "./WorkContactPickerWithInputField.vue?vue&type=script&lang=js"
export * from "./WorkContactPickerWithInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports